import {createAction} from 'redux-actions';
import {trackImpression} from '../../analytics';
import {ARTICLES_SLIDER_FETCH} from '../../action-types';

const articlesSearch = (identifier, {size, id, artNos}) => {
	const articleNumbers = typeof identifier[0] === 'string' ? identifier : identifier.map(x => x.art_no);

	return v12.search(articleNumbers, {size, query: {artNos}})
		.then(({articles}) => {
			if (!articles) {
				return {
					articles: [],
					id
				};
			}
			const {hits} = articles;
			const filteredArticles = hits.filter(x => articleNumbers.includes(x.art_no));

			trackImpression(filteredArticles);

			return {
				articles: filteredArticles,
				id
			};
		});
};

export const articlesFetch = createAction(ARTICLES_SLIDER_FETCH, (identifier, options) => {
	const {artNos, id, key, size} = options;

	if (key === 'search') {
		return articlesSearch(identifier, {size, id, artNos});
	}

	return v12.articles.get(identifier, {
		size: parseInt(size, 10),
		key,
		filter: {}
	})
		.then(data => {
			trackImpression(data.articles.hits);

			return {
				articles: data.articles.hits,
				id
			};
		});
});
